import {
	Container,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	Text,
	ContainerGutter,
	ReferenceBadge,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';

const MainContainer = styled.div`
	padding: 0px;
	align-content: center;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	padding-top: 16px;
`;

const StyledC2Wrapper = styled(Container)`
	border-top: 2px solid #00b0f0;
	border-bottom: 2px solid #00b0f0;
	align-content: center;
	padding-left: 4px;
	padding-right: 4px;
	margin-left: auto;
	margin-right: auto;
	height: 160px;
	width: 100%;
	/* padding top and bottom depends on the fixed height */
`;

const TextSuperLarge = styled(Text)`
	font-size: 87px;
	line-height: 100%;
`;

const SymbolText = styled(Text)`
	font-size: 44px;
	line-height: 120%;
`;

const StyledReferenceBadge = styled(ReferenceBadge)`
	margin-top: 15px;
`;

export const PdfRenovadoresBonusCardC2: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	const badge = '1'; // badge siempre es "1" respecto al popup/pdf

	return (
		<MainContainer data-testid="c2-container">
			<StyledC2Wrapper
				data-testid="c2-inner-container"
				stretchContent
				wrap="always"
				verticalAlign="center"
				horizontalAlign="center"
				gutter={ContainerGutter.dynamic0020}
			>
				<Text
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.center}
					bold
				>
					{'Llevas acumulado'}
				</Text>
				<Container wrap="never" horizontalAlign="center">
					<Container wrap="never" verticalAlign="flex-end">
						<TextSuperLarge color={TokenTextColor.inverted}>{dineroHucha}</TextSuperLarge>
						<SymbolText color={TokenTextColor.inverted}>{'€'}</SymbolText>
					</Container>
					<StyledReferenceBadge variant="large">{badge.replace(/\.$/, '')}</StyledReferenceBadge>
				</Container>
			</StyledC2Wrapper>
		</MainContainer>
	);
};
